import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AuthStore } from '@domains/auth/auth.store';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthStore) => () => auth.initializeAuth(),
      deps: [AuthStore],
      multi: true,
    },
  ]);
}
